import useDrawerContext from "@contexts/drawerContext"
import useYesOrNo from "@hooks/useYesOrNo"
import { size } from '@styles/theme'

import { DeletePost } from '@components/layout/bottom_drawers/elements/DrawerActions'
import { DrawerButtonGroup, DrawerContents } from './elements/DrawerLayout'
import { DrawerAvatarGroup } from './elements/DrawerAvatarGroup'
import { DrawerDisplayName } from './elements/DrawerDisplayName'
import { DrawerJoinedText } from './elements/DrawerJoinedText'
import {
  NearbyProfileButton,
  SocialProfileButton,
  DrawerCloseButton,
  DeletePostButton,
} from './elements/DrawerButtons'

const OwnPostBottomDrawerContents = ({ user, post, afterDelete }) => {
  const [isDeleteDialogOpen, openDeleteDialog, closeDeleteDialog] = useYesOrNo('posts__delete-posts')
  const { closeBottomDrawer } = useDrawerContext()

  const handlePostDeletePromise = (promise) => {
    // handle what happens after conversation is deleted successfully
    promise?.then?.(() => {
      closeBottomDrawer()
      afterDelete?.(post)
    })
  }

  return (
    <DrawerContents>
      <DeletePost
        isOpen={isDeleteDialogOpen}
        setClosed={closeDeleteDialog}
        handlePromise={handlePostDeletePromise}
        postId={post?.uuid}
      />
      <DrawerCloseButton
        setClosed={closeBottomDrawer}
        style={{ marginLeft: size(3) }}
      />
      <DrawerAvatarGroup user={user} />
      <DrawerDisplayName user={user} />
      <DrawerJoinedText
        user={user}
        style={{ marginLeft: size(5) }}
      />
      <DrawerButtonGroup style={{ paddingTop: size(1) }}>
        {user?.nearbyUuid && <NearbyProfileButton user={user} />}
        {!user?.isAnonymous && <SocialProfileButton user={user} />}
      </DrawerButtonGroup>
      <DrawerButtonGroup>
        <DeletePostButton onClick={openDeleteDialog} />
      </DrawerButtonGroup>
    </DrawerContents>
  )
}

export { OwnPostBottomDrawerContents }
